import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaDropdownContent from './VaDropdownContent.vue'

export const VaDropdownContent = withConfigTransport(_VaDropdownContent)
